<div class="box_pie_chart" [class.waiting]="waiting">
  <div class="row">
    <div class="col-12 text-align-left">
       <div class="pie_chart mx-auto" [style.width.px]="size" [style.height.px]="size">
        <ng-container *ngIf="!waiting">
          <canvas #pieChart baseChart
            [data]="pieChartData"
            [options]="pieOptions"
            [type]="pieChartType"
            [plugins]="pieChartPlugins"
            (chartClick)="chartClicked($event)"
          >
          </canvas>
        </ng-container>
      </div>

    </div>


  </div>


</div>
